<template>
  <div :class="{ 'fomentar-app-visible': showFomentarApp }">
    <div v-if="isSignedIn">
      <gibber-messenger
        :class="$vuetify.breakpoint.mobile && isFullScreen ? 'xs-msg__active' : 'xs-msg__inactive'"
        :id="($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)
          ? 'messengerHideButton' : 'messenger'"
        :username="username"
        :credentials="credentials"
        :config="config"
      ></gibber-messenger>
    </div>
    <div v-if="showFomentarApp" id="fomentarApp">
      <div class="fomentar-app-banner">
        <button
          type="button"
          class="fomentar-app-banner__close"
          aria-label="Cerrar"
          @click="closeFomentarApp"
        >
          &times;
        </button>

        <div class="fomentar-app-banner__content">
          <img
            class="fomentar-app-banner__logo"
            :src="showImgFomentarApp()"
            alt="Logo de la app"
            width="40"
            height="40"
          />
          <span class="fomentar-app-banner__text">DESCUBRE UNA MEJOR EXPERIENCIA EN LA APP</span>
        </div>

        <button
          type="button"
          class="fomentar-app-banner__cta"
          @click="downloadApp"
        >
          ABRIR APP
        </button>
      </div>
    </div>
    <v-app>
      <slot name="drawer"></slot>
      <slot name="navbar"></slot>
      <v-main ref="main">
        <v-container v-if="container" fluid fill-height>
          <slot></slot>
        </v-container>
        <slot v-else></slot>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { loadScript } from 'vue-plugin-load-script';

export default {
  data() {
    const url = window.location.href;
    const intranet = 'junta-andalucia.es';
    const virtualhostTest = process.env.VUE_APP_VIRTUAL_HOST;
    let chatServerUriTest = process.env.VUE_APP_CHAT_SERVER_URI_INTERNET;
    let pathTest = process.env.VUE_APP_PATH_INTERNET;

    if (url.includes(intranet)) {
      chatServerUriTest = process.env.VUE_APP_CHAT_SERVER_URI_INTRANET;
      pathTest = process.env.VUE_APP_PATH_INTRANET;
    }

    // Version chat 3.20.0
    const hermesConfig = {
      chatServerUri: chatServerUriTest,
      virtualhost: virtualhostTest,
      path: pathTest,
      protocol: 'websocket',
      defaultLanguage: 'es',
      chatIcon: {
        family: 'solid',
        name: 'comment-dots',
      },
      environment: 'production',
      userReconnect: true,
      keepPreviousMessages: true,
      languages: {
        en: {
          headerTitle: 'AYDI',
          inputPlaceholder: 'Message...',
          aboutUs: 'About us',
          switchTheme: 'Switch theme',
          switchLanguage: 'Switch language ({lang})',
          reconnectButtonLabel: 'Start new conversation',
          reconnectingLabel: '',
        },
        es: {
          headerTitle: 'AYDI',
          inputPlaceholder: 'Mensaje...',
          aboutUs: 'Acerca de nosotros',
          switchTheme: 'Cambiar tema',
          switchLanguage: 'Cambiar idioma ({lang})',
          inputDisabled: 'Conectando...',
          aboutUsTitle: 'Acerca del asistente',
          acceptCloseChat: 'Aceptar',
          cancelCloseChat: 'Cancelar',
          closeChatTitle: 'Cerrar chat',
          closeChatBody: 'Esta conversación se finalizará ¿Quieres continuar?',
          aboutUsContent: '<p>Esto es un ejemplo de acerca de con un enlace a <a href="https://company.com/" target="blank">mi compañia</a>.</p>',
          timeIndicator: '',
          reconnectButtonLabel: 'Comenzar nueva conversación',
          reconnectingLabel: '',
          inputBlocked: 'Bloqueado',
          dragAndDropFiles: 'Arrastra y suelta los ficheros para ser enviados',
          newMessages: 'Nuevos mensajes',
        },
      },
      messageConfig: {
        showUsersNames: false,
        autoScroll: false,
        userName: '',
        agentName: '',
        showTime: false,
        showIcons: true,
        virtualHosts: {
          dasd_genai: {
            icon: 'fas robot',
            name: 'Bot AyudaDigital',
            blockInputOnTyping: true,
            focusOnMessage: true,
          },
          dasd_idlechats: {
            icon: 'fas robot',
            name: 'Bot ayudaDIGITAL',
            blockInputOnTyping: true,
          },
          dafa_ws: {
            icon: 'fas headset',
            name: undefined,
            blockInputOnTyping: false,
          },
          mics_ws: {
            icon: 'fas user',
          },
        },
      },
      attachmentEnabled: true,
      attachMultipleFiles: true,
      bufferMessageTime: 6,
    };
    return {
      config: JSON.stringify(hermesConfig),
      isFullScreen: false,
      showFirstMessage: false,
      isMini: false,
      chatBackup: '',
      isChatReconnect: false,
      previousMessageCount: 0,
      titleInterval: null,
      originalTitle: '',
      pendingMessagesCount: 0,
      notificationTimeout: null,
      showFomentarApp: false,
      chatElement: null,
      windowFocusHandler: null,
      visibilityChangeHandler: null,
    };
  },
  props: {
    container: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      username: ({ session: { session } }) => session?.user?.userid,
      user: ({ session: { session } }) => (session != null ? session.user : null),
      credentials: ({ session: { session, storage } }) => {
        const creden = {
          username: session?.user?.userid,
          token: storage?.token,
        };
        return JSON.stringify(creden);
      },
    }),
    ...mapGetters({
      isSignedIn: 'session/isSignedIn',
    }),
  },
  created() {
    this.showFomentarApp = this.isMobileBrowser();
  },
  beforeCreate() {
    loadScript('js/hermes-messenger.js')
      .catch(() => {
        console.log('Catch loading hermes-messenger.js');
      })
      .finally(() => {
        const chat = document.getElementById('messenger')
          ? document.getElementById('messenger')
          : document.getElementById('messengerHideButton');

        chat.addEventListener('firstMessage', () => {
          this.hideAnimation();
        });

        chat.addEventListener('clientError', () => {
          this.clientError();
        });

        chat.addEventListener('messageReceived', () => {
          // const dominioJunta = 'junta-andalucia.es';
          // const dominioJuntaDeAndalucia = 'juntadeandalucia.es';

          const micsSas = 'mics.sas.junta-andalucia.es';
          const ws001 = 'ws001.sspa.juntadeandalucia.es/mics/';
          const sspa = 'sspa.juntadeandalucia.es/servicioandaluzdesalud/mics/';

          const ext1 = 'mics';
          const ext2 = 'servicioandaluzdesalud/mics';
          this.reloadTimeout();

          setTimeout(() => {
            const divs = document.querySelectorAll('div.msg.left-msg');
            const currentMessageCount = divs.length;

            // Manejar nuevos mensajes con notificación
            this.handleNewMessages(currentMessageCount);

            // Procesar enlaces
            if (divs.length > 0) {
              divs.forEach((div) => {
                const anchors = div.querySelectorAll('a[href]');
                anchors.forEach((anchor) => {
                  const href = anchor.getAttribute('href');
                  let result = '#';
                  if (href && !href.startsWith('#')) {
                    if (!href.includes(micsSas) && !href.includes(ws001) && !href.includes(sspa)) {
                      anchor.setAttribute('target', '_blank');
                    } else {
                      if (href.includes(ws001)) {
                        const parts = href.split(ws001);
                        result = parts.length > 1 ? `#${parts[1]}` : href;
                      } else if (href.includes(sspa)) {
                        const parts = href.split(sspa);
                        result = parts.length > 1 ? `#${parts[1]}` : href;
                      } else if (href.includes(`${micsSas}/${ext1}`)) {
                        const parts = href.split(`${micsSas}/${ext1}/`);
                        result = parts.length > 1 ? `#${parts[1]}` : href;
                      } else if (href.includes(`${micsSas}/${ext2}`)) {
                        const parts = href.split(`${micsSas}/${ext2}/`);
                        result = parts.length > 1 ? `#${parts[1]}` : href;
                      } else if (href.includes(`${micsSas}/`)) {
                        const parts = href.split(`${micsSas}/`);
                        result = parts.length > 1 ? `#${parts[1]}` : href;
                      } else {
                        result = href;
                      }
                      anchor.setAttribute('href', result);
                      anchor.setAttribute('target', '_self');
                    }
                  }
                });
              });
            }
          }, 500);
        });

        chat.addEventListener('userReconnect', () => {
          this.chatReconnect();
        });

        chat.addEventListener('chatClosed', () => {
          this.setNotShowFirstMessage();
        });

        const hermesButton = document.getElementsByClassName('gibber-messenger-button')[0];
        hermesButton.innerHTML = '<span class="chat-span" style="font-size: 0.85em;">Chat </span><span><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="comment-dots" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-comment-dots fa-w-16"><path fill="currentColor" d="M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z" class=""></path></svg></span>';
        hermesButton.style.border = 'none';
        hermesButton.style.background = '#27846d';
        hermesButton.style.color = 'white';
        hermesButton.style.marginRight = '20px';
        hermesButton.style.borderRadius = '25px';
        hermesButton.style.padding = '2px 10px 2px 10px';
        const hermesOpenButton = document.querySelector('.gibber-messenger-button');
        const hermesBarButton = document.querySelector('.messenger-header-options');
        const hermesMiniButton = document.querySelector('.messenger-header-options');

        if (hermesButton) {
          hermesButton.addEventListener('click', this.showAnimation);
        }

        if (hermesOpenButton) {
          hermesOpenButton.addEventListener('click', this.setFullScreen);
        }

        if (hermesBarButton) {
          hermesBarButton.addEventListener('click', this.setFullScreen);
        }

        if (hermesMiniButton) {
          hermesMiniButton.addEventListener('click', this.setMini);
        }
      });
  },
  methods: {
    // 1) detectar dispositivo movil
    isMobileByUA() {
      const ua = (navigator.userAgent || '').toLowerCase();
      return /android|iphone|ipad|ipod|windows phone/i.test(ua);
    },
    // 2) detectar WebView
    isInWebView() {
      // Flutter inappwebview
      // Si esta variable existe, significa que estamos en el webview de la app
      const flutter = !!window.flutter_inappwebview;
      return flutter;
    },
    // 3) resultado final: móvil Y navegador (no WebView/app)
    isMobileBrowser() {
      return (this.isMobileByUA() && !this.isInWebView());
    },
    downloadApp() {
      const playStore = 'https://play.google.com/store/apps/details?id=es.juntadeandalucia.msspa.ayudadigital';
      const appStore = 'https://apps.apple.com/es/app/ayudadigital/id1531469960';

      const ua = (navigator.userAgent || '').toLowerCase();
      if (/android/i.test(ua)) {
        window.open(playStore, '_blank');
      } else {
        window.open(appStore, '_blank');
      }
    },
    showAnimation() {
      const URL = window.location.host;
      let path = '';
      let urlPrefix = 'http';
      if (URL === 'mics.sas.junta-andalucia.es') {
        path = '';
        urlPrefix = 'https';
      } else if (URL === 'www.sspa.juntadeandalucia.es') {
        path = '/servicioandaluzdesalud/mics';
        urlPrefix = 'https';
      } else if (URL === 'ws001.sspa.juntadeandalucia.es') {
        path = '/mics';
        urlPrefix = 'https';
      }
      const urlTxt = `${urlPrefix}://${URL}${path}/img/ayudaDIGITAL.gif`;
      if (!this.showFirstMessage) {
        this.clearCss();
        const hermesMainContent = document.getElementsByClassName('gibber-messenger-content')[0];
        hermesMainContent.style.backgroundImage = `url(${urlTxt})`;
        hermesMainContent.style.backgroundSize = '400px';
        hermesMainContent.style.backgroundRepeat = 'no-repeat';
        hermesMainContent.style.backgroundPosition = 'center';
        this.hideMessages(true);
      }
    },
    showImgFomentarApp() {
      const URL = window.location.host;
      let path = '';
      let urlPrefix = 'http';
      if (URL === 'mics.sas.junta-andalucia.es') {
        path = '';
        urlPrefix = 'https';
      } else if (URL === 'www.sspa.juntadeandalucia.es') {
        path = '/servicioandaluzdesalud/mics';
        urlPrefix = 'https';
      } else if (URL === 'ws001.sspa.juntadeandalucia.es') {
        path = '/mics';
        urlPrefix = 'https';
      }
      const urlTxt = `${urlPrefix}://${URL}${path}/img/icons/android-chrome-192x192.png`;
      return urlTxt;
    },
    hideAnimation() {
      if (!this.showFirstMessage) {
        this.clearCss();
        this.showFirstMessage = true;
      }
      if (this.isChatReconnect) {
        this.loadMessageBackup();
      }
    },
    chatReconnect() {
      const hermesMainContent = document.getElementsByClassName('gibber-messenger-content')[0];
      this.showFirstMessage = false;
      this.isChatReconnect = true;
      this.chatBackup = hermesMainContent.innerHTML;
      this.showAnimation();
    },
    loadMessageBackup() {
      const hermesMainContent = document.getElementsByClassName('gibber-messenger-content')[0];
      hermesMainContent.innerHTML = this.chatBackup;
      this.chatBackup = '';
      this.isChatReconnect = false;
    },
    clientError() {
      const hermesMainContent = document.getElementsByClassName('gibber-messenger-content')[0];
      this.clearCss();
      hermesMainContent.style.textAlign = 'center';
      hermesMainContent.style.color = '#27846d';
      hermesMainContent.style.paddingTop = '180px';
      hermesMainContent.style.fontWeight = 'bold';
      hermesMainContent.innerHTML = '<i class="icon-ayudadigital-incidencia iconWarning"><br><br></i><span>Ya tienes iniciado un chat en otra ventana o equipo.</span>';
    },
    clearCss() {
      const hermesMainContent = document.getElementsByClassName('gibber-messenger-content')[0];
      hermesMainContent.style.backgroundImage = 'none';
      hermesMainContent.style.textAlign = '';
      hermesMainContent.style.color = '';
      hermesMainContent.style.paddingTop = '';
      hermesMainContent.style.fontWeight = '';
    },
    hideMessages(showMsg) {
      const style = showMsg === false ? 'flex' : 'none';
      const messages = document.getElementsByClassName('msg');
      for (let i = 0; i < messages.length; i += 1) {
        messages[i].style.display = style;
      }
    },
    setNotShowFirstMessage() {
      this.setcloseModal();
      this.showFirstMessage = false;
      this.clearCss();
    },
    setNotFullScreen() {
      this.isFullScreen = false;
    },
    setFullScreen() {
      const hermesOpenButton = document.querySelector('.gibber-messenger');
      if (this.isMini === false) {
        hermesOpenButton.style.zIndex = '1000';
      }
      this.isMini = false;
      this.isFullScreen = true;
      this.sendPiwik();
    },
    setcloseModal() {
      const hermesOpenButton = document.querySelector('.gibber-messenger');
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
        hermesOpenButton.style.zIndex = '-1';
      }
      this.isFullScreen = false;
    },
    setMini() {
      this.isMini = true;
      const hermesOpenButton = document.querySelector('.gibber-messenger');
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
        hermesOpenButton.style.zIndex = '-1';
      }
    },
    hasGroupTEST() {
      return this.user.KdGroupMember;
    },
    sendPiwik() {
      // eslint-disable-next-line no-undef
      _paq.push(['trackGoal', 2]);
    },
    reloadTimeout() {
      this.$api.getClient('registerSession').lastAccess();
    },
    closeFomentarApp() {
      this.showFomentarApp = false;
    },
    handleNewMessages(currentMessageCount) {
      if (currentMessageCount > this.previousMessageCount) {
        const newMessagesCount = currentMessageCount - this.previousMessageCount;

        this.previousMessageCount = currentMessageCount;

        console.log(`NUEVO MENSAJE - Total nuevos: ${newMessagesCount}`);

        // Solo proceder si la pestaña NO está visible
        if (document.hidden) {
          // Incrementar contador solo si la pestaña está oculta
          this.pendingMessagesCount += newMessagesCount;

          console.log(`Pestaña oculta - Acumulados: ${this.pendingMessagesCount}`);

          if (this.notificationTimeout) {
            clearTimeout(this.notificationTimeout);
          }

          this.notificationTimeout = setTimeout(() => {
            this.updateNotificationBlink();
            this.notificationTimeout = null;
          }, 500);
        } else {
          // Si la pestaña está visible, resetear el contador
          console.log('Pestaña visible - No se muestra notificación - Reseteando contador');
          this.pendingMessagesCount = 0;
        }
      }
    },
    updateNotificationBlink() {
      if (this.pendingMessagesCount === 0) return;

      // Verificar nuevamente si la pestaña está oculta
      if (document.hidden) {
        console.log(`Actualizando notificación con ${this.pendingMessagesCount} mensajes`);

        if (!this.titleInterval) {
          this.originalTitle = document.title;
        }

        this.clearNotificationBlink();

        let counter = 0;
        this.titleInterval = setInterval(() => {
          counter += 1;
          const isAlternate = counter % 2 === 0;
          this.toggleNotification(isAlternate, this.pendingMessagesCount);
        }, 1000);

        this.setupBlinkStopListeners();
      }
    },
    toggleNotification(showNotification, newMessagesCount) {
      document.title = showNotification
        ? `Nuevos mensajes (${newMessagesCount})`
        : this.originalTitle;
    },
    setupBlinkStopListeners() {
      this.removeBlinkStopListeners();

      // SOLO listener de visibilidad de pestaña
      this.visibilityChangeHandler = this.handleVisibilityChange.bind(this);
      document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    },
    removeBlinkStopListeners() {
      // Remover listener de visibilidad
      if (this.visibilityChangeHandler) {
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
        this.visibilityChangeHandler = null;
      }
    },
    handleVisibilityChange() {
      if (!document.hidden) {
        // El usuario ha vuelto a la pestaña
        console.log('Usuario ha vuelto a la pestaña - Deteniendo notificación');
        this.stopNotificationBlink();
      }
    },
    stopNotificationBlink() {
      console.log('Deteniendo notificación');

      this.clearNotificationBlink();

      this.pendingMessagesCount = 0;

      if (this.notificationTimeout) {
        clearTimeout(this.notificationTimeout);
        this.notificationTimeout = null;
      }

      if (this.originalTitle) {
        document.title = this.originalTitle;
      }

      this.removeBlinkStopListeners();
    },
    clearNotificationBlink() {
      if (this.titleInterval) {
        clearInterval(this.titleInterval);
        this.titleInterval = null;
      }
    },
  },
  beforeDestroy() {
    this.clearNotificationBlink();

    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
    }

    this.removeBlinkStopListeners();

    const hermesOpenButton = document.querySelector('.gibber-messenger-button');
    const hermesBarButton = document.querySelector('.messenger-header-options');

    if (hermesOpenButton) {
      hermesOpenButton.removeEventListener('click', this.setFullScreen);
    }
    if (hermesBarButton) {
      hermesBarButton.removeEventListener('click', this.setNotFullScreen);
    }
  },
};
</script>

<style lang="scss" scoped>
  .fomentar-app-visible {
    ::v-deep .v-app-bar.v-app-bar--fixed {
      position: absolute !important;
      top: 0px !important;
    }
  }

  #fomentarApp {
    position: relative;
    z-index: 1200;
    width: 100%;
    min-height: 56px;
    font-family: 'Source Sans Pro', sans-serif;
    border-bottom: 4px solid #151515;
    background: #fff;
    padding: 6px 10px;

    .fomentar-app-banner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;

      &__close {
        border: 0;
        background: transparent;
        color: #6d6d6d;
        font-size: 20px;
        line-height: 1;
        cursor: pointer;
        padding: 4px;
      }

      &__content {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      &__logo {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 8px;
      }

      &__text {
        margin: 0;
        color: #1c1c1c;
        font-family: 'Source Sans Pro', sans-serif;
        font-size: 1.125rem;
        font-weight: 600;
        line-height: 1.2;
        text-transform: uppercase;
      }

      &__cta {
        border: 0;
        border-radius: 8px;
        background: #27846d;
        color: #fff;
        font-family: 'Source Sans Pro', sans-serif;
        font-size: 0.875rem;
        font-weight: 600;
        letter-spacing: 0.03em;
        line-height: 1;
        text-transform: uppercase;
        white-space: nowrap;
        padding: 10px 14px;
        cursor: pointer;
      }
    }

    @media (max-width: 700px) {
      .fomentar-app-banner {
        gap: 6px;

        &__text {
          font-size: 13px;
        }

        &__cta {
          font-size: 12px;
          padding: 8px 10px;
        }
      }
    }
  }

  #messengerHideButton {
    ::v-deep .gibber-messenger{
      &-button {
        visibility: hidden;
      }
    }
  }

  ::v-deep .gibber-messenger {
    position: fixed;
    z-index: 1000;
    display: flex;
    flex: 1 1 100%;
    flex-direction: column;
    max-height: 100%;
    max-width: 100%;

    &-button {
      border-radius: 5px 5px 5px 5px;
      border: 2px solid #27846D !important;
      color: white !important;
      padding: 6px 6px 3px 6px;
      background-color: #eee;
      font-size: 2em !important;
      cursor: pointer;
    }
  }

  .xs-msg__active {
    ::v-deep .gibber-messenger {
      /*bottom: 20px !important;*/
      bottom: 0px !important;
      right: 0px !important;
      width: 100vw !important;
      height: 100vh !important;
      &-button {
        height: 40px;
        width: 40px;
      }

      &-chat {
        max-height: 100% !important;
        max-width: 100% !important;
        min-height: 100% !important;
        min-width: unset !important;
      }
    }
  }

  .xs-msg__inactive {
    ::v-deep .gibber-messenger {
      bottom: 45px !important;
    }
  }

  $primary: #27846D;
  $light: #FFFFFF;
  $dark: #333333;
  $gray: #EEEEEE;
  $grayDark: #bebebe;
  $skyBlue: #148FF3;
  $grey-secondary: #4D4C4C;

  ::v-deep .gibber-messenger {
    &-chat {
      min-height: 50%;
      max-height: 700px;
      height: 700px !important;
    }

    .gibber-messenger-header {
      border-top: 1px solid $dark;
      background: $light;
      color: $dark;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }

    .gibber-messenger-content {
      box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
      -webkit-box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
      -moz-box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
      border-bottom: 1px solid $gray;
      line-height: 1.5;

      .msg {
        &.left-msg .msg-bubble {
          background-color: $light;
          color: $dark;
          border: 0.8px solid $gray;
        }

        &.right-msg .msg-bubble {
          background-color: $gray;
          color: $dark;
        }

        &.left-msg .msg-file a{
          background-color: #ffffff;
          color: black;
        }

        &.right-msg .msg-file a{
          background-color: #f8f8f8;
          color: black;
        }

        &.msg.left-msg .msg-bubble .msg-text p:not(:last-child),
        &.msg.left-msg .msg-bubble .msg-text ul,
        &.msg.left-msg .msg-bubble .msg-text ol {
          margin-bottom: 15px;
        }

        &.msg.left-msg .msg-bubble .msg-text ul,
        &.msg.left-msg .msg-bubble .msg-text ol {
          padding-left: 2rem;
        }

        .msg-text-description {
          color: $grey-secondary;
        }
      }
    }

    .new-messages-button {
      background-color: #27846d !important;
      transition: background-color 0.1s ease;
    }

    .new-messages-button:hover {
      background-color: #1f6b59 !important;
    }

    .gibber-messenger-inputarea {
      background-color: $light;

      .messenger-input {
        background: $light;
        border-bottom: 2px solid $gray;
        font-size: 1em;
      }

      .messenger-input::placeholder {
        color: $grayDark;
      }

      .messenger-send-btn {
        color: $skyBlue;
      }
    }

    .iconWarning {
      font-size: 7em;
      line-height: 0.03125em;
      vertical-align: -0.1875em;
    }

    .msg-info-icon {
      color: #27846D !important;
    }
    @media (max-height: 810px) {
      .gibber-messenger {
        &-chat {
          height: 600px !important;
        }
      }
    }
  }
</style>
